module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Desert King’s Pregnant Bride")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "acknowledgePage",
    attrs: {
      "id": "ack01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_c('p', {
    staticClass: "acknowledgeText"
  }, [_c('span', [_vm._v("With warmest gratitude to:"), _c('br'), _vm._v("\nLeanne McMahon, equine expert extraordinaire;"), _c('br'), _vm._v("\nAnna Campbell, the best friend a girl could have;"), _c('br'), _vm._v("\nand my very own hero, Geoff."), _c('br'), _vm._v("\nThank you."), _c('br'), _vm._v("\nThis book wouldn’t have been"), _c('br'), _vm._v("\npossible without you!")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page06"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e014ba0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/desertkingspregnantbridethe_ack01.vue
// module id = 69
// module chunks = 0